var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _c("h5", { staticClass: "mb-4" }, [
        _vm._v(" Verificación de identidad para firma electrónica avanzada ")
      ]),
      _c(
        "b-card",
        [
          _vm.step === "SELECT_METHOD"
            ? [
                _c("div", { staticClass: "text-center mb-4" }, [
                  _c("p", { staticStyle: { color: "#4e4e4e" } }, [
                    _vm._v(
                      " Seleccione el método de verificación de identidad para generar su certificado de firma electrónica avanzada. "
                    )
                  ])
                ]),
                _c("div", { staticClass: "row px-3" }, [
                  _vm.nfcEnabled
                    ? _c(
                        "div",
                        { staticClass: "col-12 mb-4" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "primary",
                                block: "",
                                size: "lg"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.startVerification("NFC")
                                }
                              }
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-2",
                                attrs: { icon: "SmartphoneIcon" }
                              }),
                              _vm._v(" Verificación por NFC ")
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "bg-light rounded p-3 mt-2",
                              staticStyle: {
                                "border-left": "3px solid #7367f0"
                              }
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass: "mb-1",
                                  staticStyle: {
                                    color: "#4e4e4e",
                                    "font-size": "0.85rem"
                                  }
                                },
                                [
                                  _vm._v(
                                    " Se deberá descargar una aplicación para realizar una verificación de identidad con su dispositivo móvil. "
                                  )
                                ]
                              ),
                              _c(
                                "p",
                                {
                                  staticClass: "mb-0",
                                  staticStyle: {
                                    color: "#4e4e4e",
                                    "font-size": "0.85rem"
                                  }
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      "Su dispositivo debe contar con sensor NFC para continuar con esta opción."
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.bankTransferEnabled
                    ? _c(
                        "div",
                        { staticClass: "col-12 mb-3" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "outline-primary",
                                block: "",
                                size: "lg"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.startVerification("BANK_TRANSFER")
                                }
                              }
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-2",
                                attrs: { icon: "DollarSignIcon" }
                              }),
                              _vm._v(
                                " Verificación por Transferencia bancaria "
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "bg-light rounded p-3 mt-2",
                              staticStyle: {
                                "border-left": "3px solid #7367f0"
                              }
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass: "mb-1",
                                  staticStyle: {
                                    color: "#4e4e4e",
                                    "font-size": "0.85rem"
                                  }
                                },
                                [
                                  _vm._v(
                                    " Se debe realizar una transferencia bancaria desde una cuenta a su nombre. "
                                  )
                                ]
                              ),
                              _c(
                                "p",
                                {
                                  staticClass: "mb-0",
                                  staticStyle: {
                                    color: "#4e4e4e",
                                    "font-size": "0.85rem"
                                  }
                                },
                                [
                                  _vm._v(
                                    " El monto será reversado una vez confirmada su identidad. "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            : _vm._e(),
          _vm.step === "NFC_PENDING"
            ? [
                _c("div", { staticClass: "text-center" }, [
                  _c(
                    "div",
                    { staticClass: "mb-3" },
                    [
                      _c("feather-icon", {
                        staticClass: "text-primary",
                        attrs: { icon: "SmartphoneIcon", size: "42" }
                      })
                    ],
                    1
                  ),
                  _c("h5", [_vm._v("Verificación NFC en proceso")]),
                  _c("div", { staticClass: "my-4" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-inline-block rounded-circle border border-primary p-3",
                        staticStyle: {
                          width: "100px",
                          height: "100px",
                          "line-height": "70px"
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "font-weight-bold",
                            staticStyle: {
                              "font-size": "1.5rem",
                              color: "#7367f0"
                            }
                          },
                          [_vm._v(" " + _vm._s(_vm.countdownFormatted) + " ")]
                        )
                      ]
                    ),
                    _c("p", { staticClass: "text-muted mt-2 small" }, [
                      _vm._v("Tiempo restante para completar la verificación")
                    ])
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "bg-light rounded p-3 mb-4 text-left",
                      staticStyle: { "border-left": "3px solid #7367f0" }
                    },
                    [
                      _c(
                        "p",
                        {
                          staticClass: "mb-2",
                          staticStyle: {
                            color: "#4e4e4e",
                            "font-size": "0.9rem"
                          }
                        },
                        [
                          _c("strong", [
                            _vm._v("Descargue la aplicación Firmaki ID")
                          ]),
                          _vm._v(
                            " en su celular para completar la verificación NFC con su cédula de identidad. "
                          )
                        ]
                      )
                    ]
                  ),
                  _c("div", { staticClass: "row mt-3" }, [
                    _c("div", { staticClass: "col-6 text-center" }, [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-outline-dark btn-block",
                          attrs: {
                            href:
                              "https://apps.apple.com/cl/app/firmaki-id/id6756390157",
                            target: "_blank"
                          }
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-1",
                            attrs: { icon: "SmartphoneIcon", size: "14" }
                          }),
                          _vm._v(" App Store (iPhone) ")
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "col-6 text-center" }, [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-outline-success btn-block",
                          attrs: {
                            href:
                              "https://play.google.com/store/apps/details?id=id.amparo.firmaki",
                            target: "_blank"
                          }
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-1",
                            attrs: { icon: "SmartphoneIcon", size: "14" }
                          }),
                          _vm._v(" Google Play (Android) ")
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm.countdownExpired
                    ? _c(
                        "p",
                        { staticClass: "text-danger mt-4 font-weight-bold" },
                        [
                          _vm._v(
                            " El tiempo ha expirado. Por favor, inicie el proceso nuevamente. "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ]
            : _vm._e(),
          _vm.step === "LOADING_QUESTIONS"
            ? [
                _c("div", { staticClass: "text-center" }, [
                  _c(
                    "div",
                    { staticClass: "mb-4" },
                    [
                      _c("feather-icon", {
                        staticClass: "text-success",
                        attrs: { icon: "CheckCircleIcon", size: "48" }
                      })
                    ],
                    1
                  ),
                  _c("h5", [_vm._v("Identidad verificada por NFC")]),
                  _c(
                    "p",
                    {
                      staticStyle: { color: "#4e4e4e", "font-size": "0.95rem" }
                    },
                    [
                      _vm._v(
                        " Estamos solicitando las preguntas de verificación. Espere un momento. "
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "mt-3" },
                    [
                      _c("b-spinner", {
                        attrs: {
                          variant: "primary",
                          label: "Cargando preguntas..."
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            : _vm._e(),
          _vm.step === "QUESTIONS"
            ? [
                _c(
                  "div",
                  [
                    _c("h5", { staticClass: "mb-3" }, [
                      _vm._v("Preguntas de verificación de identidad")
                    ]),
                    _c(
                      "p",
                      {
                        staticClass: "mb-4",
                        staticStyle: { color: "#4e4e4e", "font-size": "0.9rem" }
                      },
                      [
                        _vm._v(
                          " Responda las siguientes preguntas para completar el proceso. "
                        )
                      ]
                    ),
                    _vm._l(_vm.securityQuestions, function(pregunta, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "mb-4" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "font-weight-bold",
                              staticStyle: { color: "#4e4e4e" }
                            },
                            [_vm._v(" " + _vm._s(pregunta.questionText) + " ")]
                          ),
                          pregunta.answerChoice && pregunta.answerChoice.length
                            ? _c("b-form-radio-group", {
                                staticClass: "mt-2",
                                attrs: {
                                  options: _vm.formatOptions(
                                    pregunta.answerChoice
                                  ),
                                  stacked: ""
                                },
                                model: {
                                  value:
                                    _vm.securityAnswers[pregunta.questionId],
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.securityAnswers,
                                      pregunta.questionId,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "securityAnswers[pregunta.questionId]"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    _c("div", { staticClass: "row mt-4 mb-3" }, [
                      _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("vs-input", {
                            staticClass: "w-100",
                            attrs: {
                              autocomplete: "off",
                              label: "Contraseña para el certificado",
                              placeholder: "Ingresar contraseña",
                              maxlength: "20",
                              type: "password"
                            },
                            model: {
                              value: _vm.password,
                              callback: function($$v) {
                                _vm.password = $$v
                              },
                              expression: "password"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("vs-input", {
                            staticClass: "w-100",
                            attrs: {
                              autocomplete: "off",
                              label: "Confirmar contraseña",
                              placeholder: "Confirmar contraseña",
                              maxlength: "20",
                              type: "password"
                            },
                            model: {
                              value: _vm.passwordConfirm,
                              callback: function($$v) {
                                _vm.passwordConfirm = $$v
                              },
                              expression: "passwordConfirm"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "mb-3" }, [
                      _c(
                        "small",
                        {
                          style: {
                            color: _vm.passwordStatus.longitud ? "green" : "red"
                          }
                        },
                        [_vm._v("Al menos 8 caracteres.")]
                      ),
                      _c("br"),
                      _c(
                        "small",
                        {
                          style: {
                            color: _vm.passwordStatus.minuscula
                              ? "green"
                              : "red"
                          }
                        },
                        [_vm._v("Al menos una letra minúscula.")]
                      ),
                      _c("br"),
                      _c(
                        "small",
                        {
                          style: {
                            color: _vm.passwordStatus.mayuscula
                              ? "green"
                              : "red"
                          }
                        },
                        [_vm._v("Al menos una letra mayúscula.")]
                      ),
                      _c("br"),
                      _c(
                        "small",
                        {
                          style: {
                            color: _vm.passwordStatus.numero ? "green" : "red"
                          }
                        },
                        [_vm._v("Al menos un número.")]
                      ),
                      _c("br"),
                      _c(
                        "small",
                        {
                          style: {
                            color: _vm.passwordStatus.especial ? "green" : "red"
                          }
                        },
                        [_vm._v("Al menos un carácter especial (!@#$%^&*.).")]
                      ),
                      _c("br"),
                      _c(
                        "small",
                        {
                          style: {
                            color: _vm.passwordStatus.iguales ? "green" : "red"
                          }
                        },
                        [_vm._v("Contraseña y confirmación iguales.")]
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "text-right mt-4" },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              variant: "primary",
                              disabled:
                                !_vm.allQuestionsAnswered ||
                                !_vm.isPasswordValid ||
                                _vm.loading
                            },
                            on: { click: _vm.submitAnswers }
                          },
                          [_vm._v(" Verificar y generar certificado ")]
                        )
                      ],
                      1
                    )
                  ],
                  2
                )
              ]
            : _vm._e(),
          _vm.step === "BANK_PENDING"
            ? [
                _c("div", { staticClass: "text-center" }, [
                  _c(
                    "div",
                    { staticClass: "mb-4" },
                    [
                      _c("feather-icon", {
                        staticClass: "text-primary",
                        attrs: { icon: "ClockIcon", size: "48" }
                      })
                    ],
                    1
                  ),
                  _c("h5", [_vm._v("Verificación en proceso")]),
                  _c(
                    "p",
                    {
                      staticStyle: { color: "#4e4e4e", "font-size": "0.95rem" }
                    },
                    [
                      _vm._v(
                        " Estamos verificando su transferencia bancaria. Este proceso puede demorar unos segundos. "
                      )
                    ]
                  ),
                  _c(
                    "p",
                    {
                      staticStyle: { color: "#4e4e4e", "font-size": "0.95rem" }
                    },
                    [
                      _c("strong", [_vm._v("No cierre esta página.")]),
                      _vm._v(
                        " Será redirigido automáticamente una vez confirmada su identidad. "
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "mt-3" },
                    [
                      _c("b-spinner", {
                        attrs: { variant: "primary", label: "Verificando..." }
                      })
                    ],
                    1
                  )
                ])
              ]
            : _vm._e(),
          _vm.step === "CERTIFICATE_QUEUED"
            ? [
                _c("div", { staticClass: "text-center" }, [
                  _c(
                    "div",
                    { staticClass: "mb-4" },
                    [
                      _c("feather-icon", {
                        staticClass: "text-warning",
                        attrs: { icon: "ShieldIcon", size: "48" }
                      })
                    ],
                    1
                  ),
                  _c("h5", [_vm._v("Generando certificado de firma")]),
                  _c(
                    "p",
                    {
                      staticStyle: { color: "#4e4e4e", "font-size": "0.95rem" }
                    },
                    [
                      _vm._v(
                        " Estamos generando su certificado de firma electrónica avanzada. "
                      )
                    ]
                  ),
                  _c(
                    "p",
                    {
                      staticStyle: { color: "#4e4e4e", "font-size": "0.95rem" }
                    },
                    [
                      _c("strong", [_vm._v("No cierre esta página.")]),
                      _vm._v(
                        " Será redirigido automáticamente en unos segundos. "
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "mt-3" },
                    [
                      _c("b-spinner", {
                        attrs: {
                          variant: "warning",
                          label: "Generando certificado..."
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            : _vm._e(),
          _vm.step === "ERROR"
            ? [
                _c("div", { staticClass: "text-center" }, [
                  _c(
                    "div",
                    { staticClass: "mb-4" },
                    [
                      _c("feather-icon", {
                        staticClass: "text-danger",
                        attrs: { icon: "XCircleIcon", size: "48" }
                      })
                    ],
                    1
                  ),
                  _c("h5", { staticClass: "text-danger" }, [
                    _vm._v("Verificación fallida")
                  ]),
                  _c(
                    "p",
                    {
                      staticStyle: { color: "#4e4e4e", "font-size": "0.95rem" }
                    },
                    [
                      _vm._v(
                        " No fue posible verificar su identidad. Esto puede ocurrir si los datos ingresados no coinciden o si hubo un problema con el proceso de verificación. "
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "bg-light rounded p-3 mb-3 text-left",
                      staticStyle: { "border-left": "3px solid #ea5455" }
                    },
                    [
                      _c(
                        "p",
                        {
                          staticClass: "mb-1",
                          staticStyle: {
                            color: "#4e4e4e",
                            "font-size": "0.85rem"
                          }
                        },
                        [
                          _c("strong", [_vm._v("Importante:")]),
                          _vm._v(
                            " El sistema permite un máximo de 3 intentos de verificación cada 24 horas. Si ha agotado sus intentos, deberá esperar antes de volver a intentarlo. "
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "mt-4" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "primary" },
                          on: { click: _vm.retry }
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-1",
                            attrs: { icon: "RefreshCwIcon" }
                          }),
                          _vm._v(" Intentar nuevamente ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }